import React from 'react';

import { PipelineStepOverview } from '@/console/features/pipelines/components/pipeline-step-overview/pipeline-step-overview';
import { PipelineStepStatusIconButton } from '@/console/features/pipelines/components/pipeline-step-status-chip/pipeline-step-status-chip.styled';
import {
  StepConnector,
  StepConnectorWrapper,
  StepsContainer,
} from '@/console/features/pipelines/components/pipeline-steps-overview/pipeline-steps-overview.styled';
import { TPipelineStepsOverviewProps } from '@/console/features/pipelines/components/pipeline-steps-overview/pipeline-steps-overview.types';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';

const STEP_WIDTH = 40;

export const PipelineStepsOverview: React.FC<TPipelineStepsOverviewProps> = ({
  steps = [],
  maxVisibleSteps = 7,
}) => {
  const visibleSteps = steps.slice(0, maxVisibleSteps);
  const remainingSteps = steps.slice(maxVisibleSteps);

  return (
    <StepsContainer
      width={STEP_WIDTH * maxVisibleSteps}
      direction="row"
      alignItems="center"
    >
      {visibleSteps.map((step, index) => (
        <React.Fragment key={`${step.type}_${index}`}>
          <PipelineStepOverview step={step} />
          {index < visibleSteps.length - 1 && (
            <StepConnectorWrapper>
              <StepConnector />
            </StepConnectorWrapper>
          )}
        </React.Fragment>
      ))}
      {remainingSteps?.length > 0 && (
        <>
          <StepConnectorWrapper>
            <StepConnector />
          </StepConnectorWrapper>
          <PopoverController
            trigger={
              <PipelineStepStatusIconButton>
                +{remainingSteps?.length}
              </PipelineStepStatusIconButton>
            }
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            {() => (
              <StepsContainer
                width="fit-content"
                direction="row"
                alignItems="center"
                padding="1rem"
              >
                {remainingSteps.map((step, index) => (
                  <React.Fragment key={`${step.type}_${index}`}>
                    <PipelineStepOverview step={step} />
                    {index < remainingSteps.length - 1 && (
                      <StepConnectorWrapper>
                        <StepConnector />
                      </StepConnectorWrapper>
                    )}
                  </React.Fragment>
                ))}
              </StepsContainer>
            )}
          </PopoverController>
        </>
      )}
    </StepsContainer>
  );
};
